<div class="section has-background-white p-3">
  <div class="is-size-6 mb-2" i18n>Table View:</div>
  <div class="buttons has-addons is-flex-wrap-nowrap mb-2">
    <button type="button" class="button is-applied mb-0" i18n>Orders</button>
    <button type="button" class="button mb-0" i18n>Transactions</button>
  </div>
  <div class="is-size-6 mb-2" i18n>Search or Filter:</div>
  <div class="columns is-vcentered">
    <div class="column">
      <portal-dropdown-search-filter
        [entities]="searchEntities"
        [defaultEntityId]="defaultSearchSelector"
      ></portal-dropdown-search-filter>
      <div class="mr-8 pr-8">
        <portal-filter-wrapper>
          <div class="control">
            <portal-transaction-filter-date
              [quickPick]="dateFilterQuickPick"
              [showQuickPicks]="true"
              [showAnyDateQuickPick]="searchTermValue !== ''"
              [selectors]="dateFilterSelectors"
              [selectedEntities]="criteriaMap"
              [showTimePicker]="true"
            ></portal-transaction-filter-date>
          </div>
          <div class="control">
            <portal-transaction-hierarchy-filters
              [selectedEntities]="criteriaMap"
              [numberOfSelectedEntities]="numberOfSelectedEntities"
              [isPreSelectedAncestorIds]="true"
              [searchSelector]="ancestorIdSelector"
            ></portal-transaction-hierarchy-filters>
          </div>
        </portal-filter-wrapper>
      </div>
      <div class="control" [ngClass]="{ 'is-flex is-justify-content-flex-end': isDeviceMobile$ }">
        <button
          class="button is-text has-text-danger mr-2"
          data-e2e="transactionsList-button-clear-filter"
          type="button"
          title="Clear filter"
          i18n-title
        >
          Clear
        </button>
        <button
          class="button is-primary"
          data-e2e="transactionsList-button-apply-filter"
          type="button"
          title="Apply filter"
          i18n-title
          i18n
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
